import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import PeopleIcon from '@mui/icons-material/People';
import BuildIcon from '@mui/icons-material/Build';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SideBar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [currentMenu, setCurrentMenu] = useState(location.pathname);
    const [isMarketOpen, setIsMarketOpen] = useState(false);
    const [isOrderOpen, setIsOrderOpen] = useState(false);
    const [isDynamicTradesOpen, setIsDynamicTradesOpen] = useState(false);
    const [isExecutionBotsOpen, setIsExecutionBotsOpen] = useState(false);
    const [isClientsOpen, setIsClientsOpen] = useState(false);
    const [isSystemOpen, setIsSystemOpen] = useState(false);
    const [isCprOpen, setIsCprOpen] = useState(false);

    useEffect(() => {
        setCurrentMenu(location.pathname);
    }, [location.pathname]);

    const handleNavigation = (route) => {
        navigate(route);
        setCurrentMenu(route);
    };

    const GroupHeader = ({ icon: Icon, label, isOpen, onToggle }) => (
        <a className="sb-group-header cursor-pointer" onClick={onToggle}>
            <span style={{ display: 'flex', alignItems: 'center' }}>
                <span className="sb-icon-box">
                    <Icon style={{ fontSize: 15 }} />
                </span>
                <span>{label}</span>
            </span>
            <i className={`pi pi-chevron-down dropdown-icon ${isOpen ? 'rotate' : ''}`}></i>
        </a>
    );

    return (
        <aside className="sidebar">
            <div className="d-flex align-items-center justify-content-between">
                <div className="justify-content-between disable-sm-screen mt-3">
                    <div className="crypt-logo dark">Trident Algo</div>
                    <div className="crypt-logo light">Trident Algo</div>
                    <div className="crypt-logo logo-sm dark">Trident Algo</div>
                    <div className="crypt-logo logo-sm light">Trident Algo</div>
                </div>
            </div>

            <div className="sb-logo-sep"></div>

            <div className="side-wrapper">
                <div className="side-menu">

                    {/* ── Market Data ── */}
                    <GroupHeader icon={TrendingUpIcon} label="Market Data"
                        isOpen={isMarketOpen} onToggle={() => setIsMarketOpen(p => !p)} />
                    <div className={`animation-dropdown ${isMarketOpen ? 'active' : ''}`}>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/exchangeMarket' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/exchangeMarket')} tabIndex={0}>
                            <span>Marketplace</span>
                        </a>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/cprScanner' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/cprScanner')} tabIndex={0}>
                            <span>CPR Scanner</span>
                        </a>
                    </div>

                    <div className="sb-divider"></div>

                    {/* ── Order Trading ── */}
                    <GroupHeader icon={FlashOnIcon} label="Order Trading"
                        isOpen={isOrderOpen} onToggle={() => setIsOrderOpen(p => !p)} />
                    <div className={`animation-dropdown ${isOrderOpen ? 'active' : ''}`}>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/liveTrading' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/liveTrading')} tabIndex={0}>
                            <span>Live Trading</span>
                        </a>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/placeOrder' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/placeOrder')} tabIndex={0}>
                            <span>Place Order</span>
                        </a>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/orderHistory' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/orderHistory')} tabIndex={0}>
                            <span>Order History</span>
                        </a>
                    </div>

                    <div className="sb-divider"></div>

                    {/* ── CPR ── */}
                    <GroupHeader icon={SmartToyIcon} label="CPR"
                        isOpen={isCprOpen} onToggle={() => setIsCprOpen(p => !p)} />
                    <div className={`animation-dropdown ${isCprOpen ? 'active' : ''}`}>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/cpr' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/cpr')} tabIndex={0}>
                            <span>Configurations</span>
                        </a>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/cprTradeHistory' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/cprTradeHistory')} tabIndex={0}>
                            <span>Trade History</span>
                        </a>
                    </div>

                    <div className="sb-divider"></div>

                    {/* ── Execution Bot ── */}
                    <GroupHeader icon={SmartToyIcon} label="Execution Bots"
                        isOpen={isExecutionBotsOpen} onToggle={() => setIsExecutionBotsOpen(p => !p)} />
                    <div className={`animation-dropdown ${isExecutionBotsOpen ? 'active' : ''}`}>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/execution/bots' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/execution/bots')} tabIndex={0}>
                            <span>Execution Bots</span>
                        </a>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/execution/trade-history' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/execution/trade-history')} tabIndex={0}>
                            <span>Trade History</span>
                        </a>
                    </div>



                    <div className="sb-divider"></div>

                    {/* ── Dynamic Trades ── */}
                    <GroupHeader icon={AutorenewIcon} label="Dynamic Trades"
                        isOpen={isDynamicTradesOpen} onToggle={() => setIsDynamicTradesOpen(p => !p)} />
                    <div className={`animation-dropdown ${isDynamicTradesOpen ? 'active' : ''}`}>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu.includes('/dynamicTradeManager') ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/dynamicTradeManager')} tabIndex={0}>
                            <span>Manage Trades</span>
                        </a>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/dynamicTradeHistory' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/dynamicTradeHistory')} tabIndex={0}>
                            <span>Trade History</span>
                        </a>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/liveMonitoring' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/liveMonitoring')} tabIndex={0}>
                            <span>Live Monitoring</span>
                        </a>
                    </div>

                    <div className="sb-divider"></div>

                    {/* ── Client Management ── */}
                    <GroupHeader icon={PeopleIcon} label="Client Management"
                        isOpen={isClientsOpen} onToggle={() => setIsClientsOpen(p => !p)} />
                    <div className={`animation-dropdown ${isClientsOpen ? 'active' : ''}`}>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/clients' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/clients')} tabIndex={0}>
                            <span>Clients</span>
                        </a>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/clientGroups' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/clientGroups')} tabIndex={0}>
                            <span>Client Groups</span>
                        </a>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/symbolGroups' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/symbolGroups')} tabIndex={0}>
                            <span>Symbol Groups</span>
                        </a>
                    </div>

                    <div className="sb-divider"></div>

                    {/* ── System ── */}
                    <GroupHeader icon={BuildIcon} label="System"
                        isOpen={isSystemOpen} onToggle={() => setIsSystemOpen(p => !p)} />
                    <div className={`animation-dropdown ${isSystemOpen ? 'active' : ''}`}>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu.includes('/apiMetrics') ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/apiMetrics')} tabIndex={0}>
                            <span>API Metrics</span>
                        </a>
                        <a className={`sb-sub-item cursor-pointer ${currentMenu === '/liveLogs' ? 'is-active' : ''}`}
                            onClick={() => handleNavigation('/liveLogs')} tabIndex={0}>
                            <span>Live Logs</span>
                        </a>
                    </div>

                </div>
            </div>
        </aside>
    );
};

export default SideBar;

